__webpack_require__.p = "/Text-Translator-App_CodeX_Intern/";